import React from 'react';
import { Link } from 'react-router-dom';
import FormOne from '../contact/FormOne';
import { useLanguage } from '../../context/LanguageContext';
import { Features } from '../../assets/features/Features';


const BannerFive = () => {
    const { language } = useLanguage();
    
    return (
        <div className="banner banner-style-5 banner-compact" style={{backgroundImage:`url(${process.env.PUBLIC_URL + "/images/banner/banner-bg-1.png"})`}}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-xl-7">
                        <div className="banner-content">
                            <h1 className="title">{Features.BANNER.WELCOME[language].split('\n').map((line, i) => <React.Fragment key={i}>{line}{i === 0 && <br/>}</React.Fragment>)}</h1>
                            <div>
                                <a href="tel:+351914440333" className="axil-btn btn-fill-primary btn-large">{Features.BANNER.CALL_NOW[language]}</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-xl-5">
                        <div className="banner-form" style={{marginTop: '-40px'}}>
                            <div className="contact-form-box shadow-box form-compact">
                                <h3 className="title">{Features.BANNER.REQUEST_QUOTE[language]}</h3>
                                <p className="subtitle-form">{Features.BANNER.QUOTE_DESCRIPTION[language]}</p>
                                <FormOne />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <style jsx>{`
                .banner-compact {
                    min-height: 100vh !important;
                    padding: 100px 0 100px 0;
                    background-size: cover !important;
                    background-position: center !important;
                    background-repeat: no-repeat !important;
                }
                .banner-content .axil-btn {
                    color: #ffffff !important;
                }
                .form-compact {
                    padding: 25px 30px !important;
                }
                .form-compact h3.title {
                    font-size: 22px;
                    margin-bottom: 8px;
                }
                .form-compact .subtitle-form {
                    font-size: 14px;
                    margin-bottom: 20px;
                }
                @media (max-width: 991px) {
                    .banner-compact {
                        min-height: auto !important;
                        padding: 60px 0 60px 0;
                    }
                }
            `}</style>
        </div>
    )
}

export default BannerFive;